/** The renewal states shared by the API trackers, verdicts and pet tracking. */
export type StatusDotState = 'up_to_date' | 'due_soon' | 'overdue' | 'unknown';

/** Tailwind background of the dot standing for each state. */
export const statusDotClasses: Record<StatusDotState, string> = {
    up_to_date: 'bg-green-500',
    due_soon: 'bg-orange-400',
    overdue: 'bg-red-500',
    unknown: 'bg-gray-300',
};

/** The dot emoji the API puts in front of its texts as a state marker, and the state each one stands for. */
export const statusDotEmojis: Record<string, StatusDotState> = {
    '🟢': 'up_to_date',
    '🟠': 'due_soon',
    '🔴': 'overdue',
    '⚪': 'unknown',
};
